/** allowedChildren가 빈 값이 아닌 editorComponents들 */
var ALL_BASIC_DISALLOWED_ANCESTORS = ['a', 'tabButton', 'carousel', 'video', 'accordionButton'];

/** allowedChildren가 빈 값이 아닌 custom editorComponents들 */
var ALL_CUSTOM_DISALLOWED_ANCESTORS = ['grid'];
var ALL_DISALLOWED_ANCESTORS = [].concat(ALL_BASIC_DISALLOWED_ANCESTORS, ALL_CUSTOM_DISALLOWED_ANCESTORS);
var getDisallowedAncestors = function getDisallowedAncestors(excludedIds) {
  return ALL_DISALLOWED_ANCESTORS.filter(function (id) {
    return !(excludedIds !== null && excludedIds !== void 0 ? excludedIds : []).some(function (excludedId) {
      return excludedId === id;
    });
  });
};

export { getDisallowedAncestors };
//# sourceMappingURL=ancestors.js.map
